import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';

@Component({
  standalone:true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports:[RouterModule, LoadSpinnerComponent]
})
export class AppComponent {
}
